import {
  AfterViewInit,
  Component,
  HostBinding,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
  inject
} from '@angular/core';
import { FilteringLogic, IgxStringFilteringOperand } from '@infragistics/igniteui-angular/core';
import {
  IGridEditDoneEventArgs, IGridEditEventArgs, IgxColumnComponent, IgxExcelExporterService, IgxPdfExporterService,
  IgxGridCell, IgxGridStateDirective, RowType
} from '@infragistics/igniteui-angular/grids/core';
import { IGX_ACTION_STRIP_DIRECTIVES, IgxActionStripModule } from '@infragistics/igniteui-angular/action-strip';
import { IGX_GRID_DIRECTIVES, IgxGridComponent, IgxGridModule } from '@infragistics/igniteui-angular/grids/grid';
import {
  IGX_INPUT_GROUP_DIRECTIVES,
  IgxInputGroupComponent,
  IgxSuffixDirective
} from '@infragistics/igniteui-angular/input-group';
import { IgxButtonDirective, IgxButtonModule, IgxFocusDirective, IgxRippleDirective, IgxRippleModule, IgxTextSelectionDirective } from '@infragistics/igniteui-angular/directives';
import { IgxIconComponent } from '@infragistics/igniteui-angular/icon';
import {ClsConfig} from '../../../util/cls-config';
import {MasOpcionesGridComponent} from '../../util/controles/mas-opciones-grid/mas-opciones-grid.component';
import {AppPresupuestosService} from '../../../core/services/app-presupuestos.service';
import {AppInfoService} from '../../../core/services/app-info.service';
import {GenericoService} from '../../../core/services/generico.service';
import {ClsUtil} from '../../../util/cls-util';
import {ClsObjCrudCatalogos} from '../../../clases-pu/02-catalogos/cls-obj-crud-catalogos';
import {EnumMasOpciones} from '../../../core/models/enum/enum-mas-opciones';
import {INeodataGridCell, INeodataMenu} from '../../../core/models/interfaces/generico-interface';
import {EnumMCGenerales} from '../../../core/models/enum/enum-menu-contextual';
import {TresPuntosComponent} from '../../util/controles/tres-puntos/tres-puntos.component';
import {EnumNombresGrids} from '../../../core/models/enum/enum-nombres-grids';
import {ClsObjConfiguracionGrid} from '../../../clases-pu/util/cls-obj-configuracion-grid';
import {ClsObjGenerico} from '../../../clases-pu/util/cls-obj-generico';
import {EnumTresPuntos} from '../../../core/models/enum/enum-tres-puntos';
import {ClsObjCopiado} from '../../../clases-pu/01-presupuesto/copiado/cls-obj-copiado';
import {DetallePegadoComponent} from '../../util/ventanas/detalle-pegado/detalle-pegado.component';
import {VtnGenericaComponent} from '../../util/ventanas/vtn-generica/vtn-generica.component';
import {FiltroGeneralModernoComponent} from '../../util/controles/filtro-general-moderno/filtro-general-moderno.component';
import {ClsObjPegado} from '../../../clases-pu/99-herramientas/pegado/cls-obj-pegado';
import {TranslateModule} from '@ngx-translate/core';
import {ContextMenuGenericoComponent} from '../../util/controles/context-menu-generico/context-menu-generico.component';
import {UppercaseDirective} from '../../../core/directivas/uppercase.directive';
import {FormsModule} from '@angular/forms';
import {PasteHandlerNeodataDirective} from '../../../core/directivas/paste-handler-neodata.directive';
import {ClsCiudades, ClsEstados} from 'src/app/core/models/cls-catalogos';
import {ClsColDetallePegado} from "../../../core/models/cls-pegado";
import {TipoMensajesService} from "../../../core/services/tipo-mensajes.service";
import {SummaryPipeNeoPipe} from "../../../core/pipes/summary-pipe-neo.pipe";
import {CrearComponenteDinamicoService} from "../../../core/services/crear-componente-dinamico.service";

@Component({
  selector: 'app-ciudades',
  templateUrl: './ciudades.component.html',
  styleUrls: ['./ciudades.component.scss'],
  imports: [
    IgxGridModule,
    IGX_GRID_DIRECTIVES,
    TranslateModule,
    FiltroGeneralModernoComponent,
    IgxIconComponent,
    MasOpcionesGridComponent,
    PasteHandlerNeodataDirective,
    IGX_INPUT_GROUP_DIRECTIVES,
    FormsModule,
    UppercaseDirective,
    IgxFocusDirective,
    IgxTextSelectionDirective,
    IgxButtonModule,
    IgxButtonDirective,
    IgxActionStripModule,
    IGX_ACTION_STRIP_DIRECTIVES,
    IgxRippleModule,
    IgxRippleDirective,
    ContextMenuGenericoComponent,
    SummaryPipeNeoPipe,
    IgxInputGroupComponent,
    IgxSuffixDirective
  ],
  providers: [SummaryPipeNeoPipe]
})
export class CiudadesComponent extends ClsConfig implements OnInit, AfterViewInit {
  private infPpto = inject(AppPresupuestosService);
  private infApp = inject(AppInfoService);
  private servicioGen = inject(GenericoService);
  private tipoMsg = inject(TipoMensajesService);
  private summaryPipe = inject(SummaryPipeNeoPipe);
  private excelExportService = inject(IgxExcelExporterService);
  private pdfExportService = inject(IgxPdfExporterService);
  private crearCompDinamico = inject(CrearComponenteDinamicoService);

  @ViewChild('gridCiudades', {read: IgxGridComponent, static: true})
  public gridCiudades: IgxGridComponent;
  @ViewChild('masOpcionesG', {read: MasOpcionesGridComponent, static: true})
  public masOpcionesG: MasOpcionesGridComponent;
  @ViewChild('filtroGeneral', {read: FiltroGeneralModernoComponent, static: true})
  public filtroGeneral: FiltroGeneralModernoComponent;
  @Input()
  public modoEdicion = true;
  // ajuste de texto
  @HostBinding('class') public themesClass = 'noAjustarTexto';
  public clicked = false;

  public tresPuntosEstado: TresPuntosComponent;

  public errorAlCargar: boolean;
  public dataCiudades: ClsCiudades[] = [];
  public activarBotones = false;
  // mostrar actionStrip
  public showActionStrip = true;
  // clase catalogos
  public mObjCRUDCatalogos: ClsObjCrudCatalogos = new ClsObjCrudCatalogos();
  private mObjGenerico: ClsObjGenerico = new ClsObjGenerico();
  private mObjCopiado: ClsObjCopiado = new ClsObjCopiado();
  private mObjPegado: ClsObjPegado = new ClsObjPegado();
  // menucontextual
  public verContextMenu = false;
  public contextmenuX = 0;
  public contextmenuY = 0;
  public cellMenuContextaul: IgxGridCell;
  public menus: INeodataMenu[] = [];
  public lengthMenu: number;
  public subMenusOpciones: any[];
  public sizeMenu = '';
  // CONFIGGRIDS: definir cada ng-Template que tengamos en el HTML
  @ViewChild('ciudadHeaderTemplate', {static: true}) public ciudadHeaderTemplate: TemplateRef<any>;
  @ViewChild('ciudadEditorTemplate', {static: true}) public ciudadEditorTemplate: TemplateRef<any>;
  @ViewChild('descripcionCiudadHeaderTemplate', {static: true}) public descripcionCiudadHeaderTemplate: TemplateRef<any>;
  @ViewChild('desCiudadEditorTemplate', {static: true}) public desCiudadEditorTemplate: TemplateRef<any>;
  @ViewChild('edoDescripcionHeaderTemplate', {static: true}) public edoDescripcionHeaderTemplate: TemplateRef<any>;
  @ViewChild('estadoDescripcionEditorTemplate', {static: true}) public estadoDescripcionEditorTemplate: TemplateRef<any>;
  @ViewChild(IgxGridStateDirective, {static: true}) public state;
  // Grid Layout
  public mObjConfigGrids: ClsObjConfiguracionGrid = new ClsObjConfiguracionGrid();
  // ConfigGridLayout
  public optionsGridLocal = {
    cellSelection: true,
    rowSelection: false,
    filtering: false,
    advancedFiltering: true,
    paging: true,
    sorting: false,
    groupBy: true,
    columns: true,
    expansion: true,
    rowPinning: false,
    columnSelection: true
  };
  public vtnGenerico: VtnGenericaComponent;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.gridCiudades.data = [];
  }

  public ngAfterViewInit() {
    // se genera la plantilla default del grid
    const stateDefault = this.state.getState(true);

    this.mObjConfigGrids.saveGridState(EnumNombresGrids.Ciudades, true, stateDefault, '', this.clicked);
    const state = this.mObjConfigGrids.initGridState(EnumNombresGrids.Ciudades);
    if (!ClsUtil.esNulo(state[0])) {
      this.state.setState(state[0]);
    }
    this.clicked = state[1];
    const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
    this.themesClass = result.themesClass;
    this.clicked = result.clicked;
  }

  public onColumnInit(column: IgxColumnComponent) {
    switch (column.field) {
      case 'Ciudad':
        column.headerTemplate = this.ciudadHeaderTemplate;
        column.inlineEditorTemplate = this.ciudadEditorTemplate;
        column.summaries = this.summaryPipe.transform('filasSummary');
        break;
      case 'DescripcionCiudad':
        column.headerTemplate = this.descripcionCiudadHeaderTemplate;
        column.inlineEditorTemplate = this.desCiudadEditorTemplate;
        break;
      case 'CodigoEstado':
        column.headerTemplate = this.edoDescripcionHeaderTemplate;
        column.inlineEditorTemplate = this.estadoDescripcionEditorTemplate;
        break;
    }
  }

  public async cargarCiudades() {
    if (!ClsUtil.esNulo(this.infPpto.organizacion)) {
      try {
        this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.GET_CATALOGOS');
        this.mObjCRUDCatalogos.dataCatalogo = [];
        this.dataCiudades = [];
        await this.mObjCRUDCatalogos.obtenerCatalogo(0, 'ConsultarCiudades2021');
        this.mObjCRUDCatalogos.dataCatalogo.forEach(ciudad => {
          const ciudad2: ClsCiudades = {
            IdCiudad: ciudad.IdCiudad,
            Ciudad: ciudad.Ciudad,
            DescripcionCiudad: ciudad.DescripcionCiudad,
            IdEstado: ciudad.IdEstado,
            CodigoEstado: ciudad.Estado.Estado,
            NombreEstado: ciudad.Estado.NombreEstado
          };
          this.dataCiudades.push(ciudad2);
        });
        this.gridCiudades.data = this.dataCiudades;
        this.errorAlCargar = false;
        this.tipoMsg.cerrarWaitDialog();
      } catch (e) {
        this.tipoMsg.cerrarWaitDialog();
        this.errorAlCargar = true;
        this.tipoMsg.mostrarMsg(e.message, 'error');
      }
    }
  }

  public menuContextual(evt: any) {
    evt.event.preventDefault();
    this.disableContextMenu();
    this.disableAllContextMenu();
    this.menus = this.mObjCRUDCatalogos.crearMenuContextual({
      esCliente: false,
      esUnidad: false,
      esEmpresa: false
    }, this.infPpto.esPptoMaestro);
    this.subMenusOpciones = [];
    this.lengthMenu = this.menus.filter(x => !x.disabled).length;
    this.contextmenuX = ClsUtil.calcPosition(document.body.clientWidth, evt.event.clientX, true, this.lengthMenu);
    this.contextmenuY = ClsUtil.calcPosition(document.body.clientHeight, evt.event.clientY, false, this.lengthMenu);
    this.sizeMenu = (this.lengthMenu * 37) + 'px';
    this.cellMenuContextaul = evt.cell;
    this.verContextMenu = true;
  }

  public disableContextMenu() {
    if (this.verContextMenu) {
      this.verContextMenu = false;
    }
  }

  public disableAllContextMenu() {
    this.mObjGenerico.disableAllContextMenu(this.infPpto);
  }

  public async customKeydown(eventArgs) {
    const ctrl = eventArgs.ctrlKey;
    const key = eventArgs.keyCode;
    // Ctrl-C ||  Cmd-C
    if ((ctrl || eventArgs.metaKey) && key === 67) {
      await this.copiarData();
    }
  }

  public async copiarData() {
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.COPIANDO');
      const msg: string = await ClsUtil.copiarDatosGrids(this.gridCiudades, 'IdCiudad', this.mObjGenerico);
      msg && this.tipoMsg.mostrarToast(msg);
    } catch (e) {
      throw new Error(e.message);
    } finally {
      this.tipoMsg.cerrarWaitDialog();
    }
  }

  public async accionSeleccionada(evt: INeodataGridCell) {
    try {
      switch (evt.accionMenu.id) {
        case EnumMCGenerales.Copiar:
          await this.copiarData();
          break;
        case EnumMCGenerales.Pegar:
          let data: any = await navigator.clipboard.readText().then((data2) => data2);
          data = this.pasteHandlerNeo.processData(data);
          await this.datosPegadosDesdeExcel(data);
          break;
        case EnumMasOpciones.Ajustar:
          const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
          this.themesClass = result.themesClass;
          this.clicked = result.clicked;
          break;
        case EnumMCGenerales.GuardarLayout:
          const state = this.state.getState(true);
          this.mObjConfigGrids.saveGridState(EnumNombresGrids.Ciudades, false, '', state, !this.clicked);
          break;
        case EnumMCGenerales.ReestablecerLayout:
          this.restoreGrid();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public restoreGrid() {
    const stateDefault = this.mObjConfigGrids.restoreGrid(EnumNombresGrids.Ciudades);
    if (!ClsUtil.esNulo(stateDefault[0])) {
      this.state.setState(stateDefault[0]);
    }
    this.clicked = stateDefault[1];
    const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
    this.themesClass = result.themesClass;
    this.clicked = result.clicked;
  }

  public clearInput() {
    this.filtroGeneral.input.value = '';
    this.gridCiudades.clearFilter();
  }

  public filterInput(filtro: string) {
    this.gridCiudades.filteringLogic = FilteringLogic.Or;
    this.gridCiudades.filterGlobal(filtro, IgxStringFilteringOperand.instance().condition('contains'));
  }

  public rowEditEnter(e: IGridEditEventArgs) {
    this.showActionStrip = false;
  }

  public rowEditExit() {
    this.showActionStrip = true;
  }

  // evento que se ocupa para guardar o modificar
  public async addUpdateCiudad(ciudad: IGridEditDoneEventArgs) {
    const newValor: ClsCiudades = ciudad.newValue;
    const oldValor: ClsCiudades = ciudad.oldValue;
    if (!ClsUtil.esNulo(this.tresPuntosEstado)) {
      newValor.IdEstado = this.tresPuntosEstado.idDefault;
      newValor.CodigoEstado = this.tresPuntosEstado.valorDefault;
    }
    if (ciudad.isAddRow) {
      await this.agregarModificarCiudad(newValor, oldValor, ciudad.isAddRow);
    } else {
      // al editar los campos, validar que sean distintos para ocupar el servicio
      if (this.mObjCRUDCatalogos.validarSiCambioCamposCatalogos(newValor, oldValor, EnumTresPuntos.Ciudades)) {
        await this.agregarModificarCiudad(newValor, oldValor, ciudad.isAddRow);
      }
    }
  }

  private async agregarModificarCiudad(newCiudad: ClsCiudades, oldCiudad: ClsCiudades, isAddRow: boolean) {
    let respuesta: bigint;
    const objCatalogo: ClsCiudades = new ClsCiudades();
    try {
      objCatalogo.IdCiudad = isAddRow ? ClsUtil.parseJSONBig(0) : newCiudad.IdCiudad;
      objCatalogo.Ciudad = newCiudad.Ciudad.toUpperCase();
      objCatalogo.DescripcionCiudad = newCiudad.DescripcionCiudad;
      objCatalogo.IdEstado = newCiudad.IdEstado;
      this.tipoMsg.mostrarWaitDialog(isAddRow ? 'MENSAJES.WAIT.GUARDANDO_CATALOGO' : 'MENSAJES.WAIT.MODIFICANDO_CATALOGO');
      respuesta = await this.mObjCRUDCatalogos.agregarModificarCatalogo([objCatalogo], 'CiudadesRegistraActualiza2021');
      if (isAddRow) {
        newCiudad.IdCiudad = respuesta;
      }
      this.tipoMsg.mostrarToast(isAddRow ? 'MENSAJES.TOAS.GUARDANDO_CATALOGO' : 'MENSAJES.TOAS.MODIFICANDO_CATALOGO');
      this.tresPuntosEstado = undefined;
      this.tipoMsg.cerrarWaitDialog();
    } catch (e) {
      this.tipoMsg.cerrarWaitDialog();
      this.cancelarAddUpdateCiudades(newCiudad, oldCiudad, isAddRow);
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  // se ocupa cuando manda error al intentar agregar o modificar,
  // al agregar si manda error se quita la fila del grid
  // al editar si manda error se regresa a los valores anteriores
  private cancelarAddUpdateCiudades(newCiudad: ClsCiudades, oldCiudad: ClsCiudades, isAddRow: boolean) {
    if (isAddRow) {
      this.gridCiudades.deleteRowById(newCiudad.IdCiudad);
    } else {
      this.gridCiudades.updateRow(oldCiudad, oldCiudad.IdCiudad);
    }
    this.tresPuntosEstado = undefined;
  }

  private async eliminarCiudad(rowContext: RowType) {
    const ciudad: ClsCiudades = rowContext.data;
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.ELIMINANDO_CATALOGO', undefined, 'delete');
      await this.mObjCRUDCatalogos.eliminarCatalogo(ciudad.IdCiudad, 'EliminarCiudades2021');
      this.gridCiudades.getRowByIndex(rowContext.index).delete();
      this.tipoMsg.mostrarToast('MENSAJES.TOAS.ELIMINANDO_CATALOGO');
      this.tipoMsg.cerrarWaitDialog();
    } catch (e) {
      this.tipoMsg.cerrarWaitDialog();
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  // se ocupa el evento rowEdit para validar uno o varios campos obligatorios,
  // si falta algun campo de toda la fila se cancela la edicion y se manda mensaje de que campos faltan
  // en caso de ser todo OK, procede al agregado o modificado
  public validarCiudad(ciudad: IGridEditEventArgs) {
    const valor: ClsCiudades = ciudad.newValue;
    ciudad.cancel = this.esValido(valor, ciudad, ciudad.isAddRow);
  }

  // en este caso se pasa el valor de la ciudad, ya que es el unico campo obligatorio,
  // en caso de ser mas campos a validar, pasar toda la clase
  private esValido(ciudades: ClsCiudades, ciu: any, isAddRow: boolean): boolean {
    // validar campos obligatorios
    if (ClsUtil.esNulo(ciudades.Ciudad)) {
      this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertValidarCampos(this.mObjGenerico.getTranslationValidarColuma('GRIDS.CIUDAD.COL_CIUDAD')));
      return true;
    }

    if (ClsUtil.esNulo(ciudades.DescripcionCiudad)) {
      this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertValidarCampos(this.mObjGenerico.getTranslationValidarColuma('GRIDS.CIUDAD.COL_DESCRIPCION')));
      return true;
    }

    if (ClsUtil.esNulo(ciudades.CodigoEstado)) {
      if (ClsUtil.esNulo(this.tresPuntosEstado)) {
        this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertValidarCampos(this.mObjGenerico.getTranslationValidarColuma('GRIDS.CIUDAD.COL_ESTADO')));
        return true;
      }
    }
    // validar cuando se agrega nuevo registro
    if (isAddRow) {
      if (this.dataCiudades.findIndex(ciudad => ciudad.Ciudad === ciudades.Ciudad) !== -1) {
        this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertRegistroExistente(ciudades.Ciudad));
        return true;
      }
    } else {
      if (ciudades.Ciudad !== ciu.oldValue.Ciudad) {
        if (this.dataCiudades.findIndex(ciudad => ciudad.Ciudad === ciudades.Ciudad) !== -1) {
          this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertRegistroExistente(ciudades.Ciudad));
          return true;
        }
      }
    }
    return false;
  }

  public accionStripRowBtn(rowContext: RowType, indexBtn: number) {
    try {
      switch (indexBtn) {
        case 1:
          this.beginAddRowByIndexNeo(this.gridCiudades, rowContext.index);
          break;
        case 2:
          this.tipoMsg.mostrarQuestion(async (resp: boolean) => {
            if (resp) {
              await this.eliminarCiudad(rowContext);
            }
          }, this.mObjGenerico.getTranslationsQuestionBorrar(rowContext.data.Ciudad));
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public async onSelectionDropDown(opcion: string) {
    try {
      switch (opcion) {
        case EnumMasOpciones.Ajustar:
          const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
          this.themesClass = result.themesClass;
          this.clicked = result.clicked;
          break;
        case EnumMasOpciones.ExportarExcel:
          const sms = await ClsUtil.exportarDatos(this.gridCiudades, this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.CIUDADES'), this.excelExportService).then(sms => { return sms });
          this.tipoMsg.mostrarToast(this.mObjGenerico.getTranslationsSmsExportar(sms, this.gridCiudades.selectedRows.length));
          break;
        case EnumMasOpciones.ExportarPDF:
          await ClsUtil.abrirVentanaPersonalizarPDF(
            this.gridCiudades,
            this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.CIUDADES'),
            this.pdfExportService,
            this.crearCompDinamico,
            this.tipoMsg,
            this.mObjGenerico
          );
          break;
        case EnumMasOpciones.Actualizar:
          await this.cargarCiudades();
          break;
        case EnumMasOpciones.LimpiarFiltroColumnas:
          this.clearInput();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public async onOpen(input: any) {
    const selectRows: any = [this.tresPuntosEstado?.idDefault];
    this.tresPuntosEstado = this.crearCompDinamico.crearComponente(TresPuntosComponent).instance as TresPuntosComponent;
    this.tresPuntosEstado.tipoCatalogo = EnumTresPuntos.Estados;
    this.tresPuntosEstado.selectedRows = selectRows;
    await this.tresPuntosEstado.onOpen();
    this.tresPuntosEstado.eventFilaSeleccionada.subscribe((valor: ClsEstados) => {
      input.value = valor.Estado
    });
  }

  public handleRowSelection() {
    this.gridCiudades.nativeElement.focus();
  }

  public async datosPegadosDesdeExcel(datosPegado: any[]) {
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.PEGANDO');
      let arrayCiudades: ClsCiudades[] = [];
      let dataDetalle: ClsColDetallePegado[];
      const colCiudad: string = this.mObjGenerico.getTranslationsSubject('GRIDS.CIUDAD.COL_CIUDAD');
      const colDesCiudad: string = this.mObjGenerico.getTranslationsSubject('GRIDS.CIUDAD.COL_DESCRIPCION');
      const colEdo: string = this.mObjGenerico.getTranslationsSubject('GRIDS.CIUDAD.COL_ESTADO');
      this.mObjCopiado.columnasRequeridas = [colCiudad, colDesCiudad, colEdo];
      if (this.mObjCopiado.validarCamposRequeridos(datosPegado)) {
        let datos = this.mObjCopiado.procesarDatos(datosPegado, true);
        datos = this.mObjPegado.mergeDescriptions(datos, EnumNombresGrids.Ciudades);
        dataDetalle = this.mObjPegado.verificarDetallePegado(datos, [colCiudad, colDesCiudad, colEdo], [colCiudad, colDesCiudad, colEdo], EnumNombresGrids.Ciudades, this.mObjGenerico);
        if (dataDetalle.length > 0) {
          const vtnGenerico = this.crearCompDinamico.crearComponente(VtnGenericaComponent).instance as VtnGenericaComponent;
          vtnGenerico.queVtnEstaAbierta = 'PegadoEspecial';
          const vtnDiferencia = vtnGenerico.crearComponente(DetallePegadoComponent);
          vtnDiferencia.dataDetalle = dataDetalle;
          vtnDiferencia.open();
        } else {
          datos.forEach(x => {
            const valCiudad: string = (x[colCiudad] as string).toUpperCase();
            // validamos la cadena, si es undefine o null, le asignamos '' en caso contrario el valor
            // esto se hace porque la columna descripcion no es obligado, puede venir o no
            const valDesCiudad: string = ClsUtil.toSubstring(x[colDesCiudad] as string, 40);
            const valEdo: string = (x[colEdo] as string).toUpperCase();
            const resp: any = this.mObjCRUDCatalogos.crearObjCatalogos(this.dataCiudades, [valCiudad, valDesCiudad, valEdo], [colCiudad, colDesCiudad, valEdo], EnumTresPuntos.Ciudades, this.mObjGenerico);
            if (!ClsUtil.esNulo(resp.esNuevo)) {
              if (resp.esNuevo) {
                arrayCiudades.push(resp.obj);
              } else {
                this.gridCiudades.updateCell(valDesCiudad, resp.obj.IdCiudad, 'DescripcionCiudad');
                this.gridCiudades.updateCell(valEdo, resp.obj.IdCiudad, 'CodigoEstado');
                arrayCiudades.push(resp.obj);
              }
            }
          });
          // invocar servicio para agregar o modificar siempre y cuando el arrayUnidades tenga valor
          if (arrayCiudades.length > 0) {
            const respuesta: any = await this.mObjCRUDCatalogos.agregarModificarCatalogo(arrayCiudades, 'CiudadesRegistraActualizaCod', false);
            // filtro los registros con id 0
            arrayCiudades = arrayCiudades.filter(value => value.IdCiudad === BigInt(0));
            // iteramos la respuesta para ir asignando los ids para los registros nuevos
            const key: string[] = Object.keys(respuesta);
            key.forEach(x => {
              const ciu: ClsCiudades = arrayCiudades.find(value1 => value1.Ciudad === x);
              if (!ClsUtil.esNulo(ciu)) {
                ciu.IdCiudad = ClsUtil.bigintX(respuesta[x]);
                this.gridCiudades.addRow(ciu);
              }
            });
          }
        }
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message);
    } finally {
      this.tipoMsg.cerrarWaitDialog();
    }
  }

  public clearProps() {
    this.gridCiudades.clearSort();
    this.gridCiudades.clearFilter();
    this.gridCiudades.clearSearch();
    this.gridCiudades.deselectAllRows();
    this.clearInput();
  }

  public registroSeleccionado() {
    const rowSeleccionados: bigint[] = this.gridCiudades.selectedRows;
    try {
      if (rowSeleccionados.length === 0) {
        throw new Error('MENSAJES.ALERT.SELECCIONAR_REGISTRO');
      }
      const rowData = this.gridCiudades.getRowData(rowSeleccionados[0]);
      this.gridCiudades.doubleClick.emit(rowData);
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }
}
